import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class TopBarMenu {
  toggled = false;

  menus = [
    
    /*{
      title: "Accueil",
      code: "tableau_de_bord",
      Url: "/dashboard/performance",
      icon: "fa fa-bar-chart",
      class: { "margin-left": "10px", color: "white", "font-weight": "normal" },
      permission: "for_all",
      type: "simple",
      submenus: null
    },*/

    {
      title: "Dashboard",
      code: "new_tableau_de_bord",
      Url: "/personnel/performance",
      icon: "fa fa-bar-chart",
      class: { "margin-left": "10px", color: "white", "font-weight": "normal" },
      permission: "for_all",
      type: "simple",
      submenus: null
    },
    // Client
    {
      title: "Client",
      code: "client",
      Url: "/crm/client",
      icon: "fa fa-bar-chart",
      class: { "margin-left": "10px", color: "white", "font-weight": "normal" },
      permission: "client",
      type: "simple",
      submenus: null
    },
    {
      title: "Workflow",
      code: "workflow",
      Url: "/mon-portefeuille/mes-dossiers",
      icon: "fa fa-bar-chart",
      class: { "margin-left": "10px", color: "white", "font-weight": "normal" },
      permission: "for_all",
      type: "simple",
      submenus: null
    },

    {
      title: "BI",
      code: "bi",
      Url: "/reporting/audience",
      icon: "fa fa-bar-chart",
      class: { "margin-left": "10px", color: "white", "font-weight": "normal" },
      permission: "bi",
      type: "simple",
      submenus: null
    },

    {
      title: "Suivi portefeuille",
      code: "suivi-portefeuille",
      Url: "/suivi-portefeuille/historique-importation",
      icon: "fa fa-bar-chart",
      class: { "margin-left": "10px", color: "white", "font-weight": "normal" },
      permission: "contentieux",
      type: "simple",
      submenus: null
    },

    {
      title: "Fonds propres",
      code: "fonds_propres",
      Url: "/fonds-propres",
      icon: "fa fa-bar-chart",
      class: { "margin-left": "10px", color: "white", "font-weight": "normal" },
      permission: "fonds_propres",
      type: "simple",
      submenus: null
    },

    {
      title: "Support client",
      code: "support-client",
      Url: "/support-client/contact-support-client",
      icon: "fa fa-bar-chart",
      class: { "margin-left": "10px", color: "white", "font-weight": "normal" },
      permission: "for_all",
      type: "simple",
      submenus: null
    }
  ];

  constructor() {}

  toggle() {
    this.toggled = !this.toggled;
  }

  getSidebarState() {
    return this.toggled;
  }

  setSidebarState(state: boolean) {
    this.toggled = state;
  }

  getMenuList() {
    return this.menus;
  }

  getMenuCodeByLink() {
    this.menus.forEach(element => {});
  }

  toggleActiveLink() {
    const link = String(window.location.href);

    this.menus.forEach(element => {
      element.class = {
        "margin-left": "10px",
        color: "white",
        "font-weight": "normal"
      };

      if (
        element.type === "simple" &&
        window.location.origin + "/#" + element.Url === link
      ) {
        element.class = {
          "margin-left": "10px",
          color: "white",
          "font-weight": "bold"
        };
      }
    });

    return this.menus;
  }
}
